import globals from '../shared/globals';
import { ebene2Regex, ebene3Regex } from './businessLogic';

/**
 * Takes an ebene 2 or ebene 3 product code and returns a function that
 * tests an ebene 3 product code for a match
 * If ebene 1 code was provided - returns a function that tests the beginning of the string to match
 *
 * @param {string} code
 * @return {Function} Function that takes a string paraneter and tests it agains predefined
 * regex based on the code passed
 */
export const makeCodeTest = ( code ) => {
	if ( ! code ) {
		return () => false;
	}

	let regex = `^${ code }`;
	const matches = code.match( ebene2Regex );
	if ( matches ) {
		regex = `^${ matches[ 1 ] }_${ matches[ 2 ] }_[^_]+_${ matches[ 3 ] }$`;
	} else if ( ebene3Regex.test( code ) ) {
		regex = `^${ code }$`;
	}
	return ( str ) => new RegExp( regex, 'i' ).test( str );
};

export const isEbene2Code = ( code ) => ebene2Regex.test( code );

export const isEbene3Code = ( code ) => ebene3Regex.test( code );

const sessionStorage = window.sessionStorage;

export const getProductCode = () => {
	return sessionStorage.getItem( 'prefill_product_code' ) || '';
};

export const updateProductCode = () => {
	const { prefillProductcode, isPageContainsForm, isTesting } = globals;

	if ( prefillProductcode ) {
		sessionStorage.setItem( 'prefill_product_code', prefillProductcode );
	} else if ( ! isPageContainsForm && ! isTesting ) {
		clearProductCode();
	}
};

export const clearProductCode = () => {
	sessionStorage.removeItem( 'prefill_product_code' );
};

export const getPrefillForm = () => {
	return sessionStorage.getItem( 'prefill_form' ) || '';
};

export const updatePrefillForm = () => {
	const { prefillForm, isPageContainsForm, isTesting } = globals;

	if ( prefillForm ) {
		sessionStorage.setItem( 'prefill_form', prefillForm );
	} else if ( ! isPageContainsForm && ! isTesting ) {
		clearPrefillForm();
	}
};

export const clearPrefillForm = () => {
	sessionStorage.removeItem( 'prefill_form' );
};

export const getWebsiteCode = () => {
	return sessionStorage.getItem( 'prefill_website_code' ) || '';
};

export const updateWebsiteCode = () => {
	const { currentWebsitecode, isPageContainsForm, isTesting } = globals;

	if ( currentWebsitecode ) {
		sessionStorage.setItem( 'prefill_website_code', currentWebsitecode );
	} else if ( ! isPageContainsForm && ! isTesting ) {
		clearWebsiteCode();
	}
};

export const clearWebsiteCode = () => {
	sessionStorage.removeItem( 'prefill_website_code' );
};

export const clearAllPrefill = () => {
	clearPrefillForm();
	clearWebsiteCode();
	clearProductCode();
};
